module.exports = __webpack_public_path__ + "assets/img/scfkm.1bad915d.png";